// extracted by mini-css-extract-plugin
export default {"tupacGrid":"nk-z","tupacHeader":"ok-z","tupacHeader2":"pk-z","tupacMenu":"qk-z","tupacMenu2":"rk-z","tupacMain":"sk-z","tupacMain2":"tk-z"};